import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import BackButton from "../../../components/custom/BackButton";
import AddItemView from "./AddItemView";
import { AttributeDefinition, Department, ItemType, NewItemPayload } from "./types";
import { HeaderContainer } from "./styles";

interface AddItemModalProps {
    modal: boolean;
    setModal: (open: boolean) => void;
    departments: Department[];
    itemTypes: ItemType[];
    defsForType: (typeId: number) => AttributeDefinition[];
    onAdd: (payload: NewItemPayload) => void;
}

export default function AddItemModal({ modal, setModal, departments, itemTypes, defsForType, onAdd }: AddItemModalProps) {
    const toggle = () => setModal(!modal);

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={"d-flex"}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={"pl-2"}>Add an item</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <AddItemView departments={departments} itemTypes={itemTypes} defsForType={defsForType} onAdd={onAdd} />
            </ModalBody>
        </Modal>
    );
}
